import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes.ts'

import {
  UmrahApplicationCard,
  UmrahCardList,
  UmrahCardListSkeleton,
  UmrahPromoWrapper,
} from 'pages/umrah/main-page/components'

import { HeaderTabs } from 'widgets/header-tabs'

import umraListStore from 'entities/umrah/models/umrah-list.ts'
import { UmrahEmpty } from 'entities/umrah/ui'
import userStore from 'entities/user/module/user-store.ts'

import { BottomNavigation } from 'shared/ui/bottom-navigation'
import { SimpleLoader } from 'shared/ui/simple-loader'

import s from './styles.module.scss'

const MainPage = observer(() => {
  const navigate = useNavigate()

  const user = userStore.getAccountInfo()
  const umraList = umraListStore.getUmrahList()
  const lastTour = umraListStore.getUmrahLastTour()

  const handleClickCard = () => {
    navigate(RoutingPaths.myOrders.path())
  }

  useEffect(() => {
    if (!lastTour && !!user) void umraListStore.requestUmraLastTour()
  }, [lastTour, user])

  return (
    <UmrahPromoWrapper>
      <div className={s.container}>
        <div className={clsx('bgGrey', s.box)}>
          <HeaderTabs module="umrah" />

          {lastTour && (
            <div className={s.cardBox}>
              <UmrahApplicationCard
                order={lastTour}
                onClick={handleClickCard}
              />
            </div>
          )}
        </div>

        {umraListStore.loading ? (
          <UmrahCardListSkeleton />
        ) : umraList?.length === 0 ? (
          <UmrahEmpty />
        ) : (
          <>
            <UmrahCardList tours={umraList} />
            {umraListStore.loading && <SimpleLoader />}
          </>
        )}
      </div>

      <BottomNavigation activeId="home" />
    </UmrahPromoWrapper>
  )
})

export default MainPage
